








































































import {Vue, Component, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import countrys from '@/const/words/deliveryCountry';
import {popupResize} from '@/utils/ncp';
import _ from 'underscore';
import {PostAreafee, AreafeeDetail, PostAreafeesRequest} from 'supporter';

@Component({
  components: {
    CompSelectBox
  }
})
export default class DeliveryAreaFeeAddForm extends Vue {
  private countryCd = 'KR';
  private areaFee: PostAreafee | null = null;
  private countrys = countrys;
  @Watch('areaFee.countryCd')
  onCountryCdChanged(newVal: string, oldVal: string) {
    if (oldVal) {
      this.$api
        .getAreas({
          params: {
            countryCd: newVal
          }
        })
        .then(ret => {
          const details: AreafeeDetail[] = [];
          ret.data.forEach(item => {
            details.push({
              address: item.address,
              areaNo: item.areaNo,
              state: item.state,
              extraDeliveryAmt: 0
            });
          });
          (this.areaFee as PostAreafee).details = details;
        });
    }
  }
  fetchAreaFee(areaFeeNo: number) {
    this.$api
      .getAreafeesByAreaFeeNo({
        params: {
          areaFeeNo: String(areaFeeNo)
        }
      })
      .then(ret => {
        if (ret && ret.data) {
          this.areaFee = ret.data;
          this.areaFee.name = '';
        }
      });
  }
  created() {
    if (this.$route.query.hasOwnProperty('deliveryAreaFeeNo')) {
      const areaFeeNo = this.$route.query.deliveryAreaFeeNo;
      this.fetchAreaFee(Number(areaFeeNo));
    } else {
      this.$api
        .getAreas({
          params: {
            countryCd: this.countryCd
          }
        })
        .then(ret => {
          const details: AreafeeDetail[] = [];
          ret.data.forEach(item => {
            details.push({
              address: item.address,
              areaNo: item.areaNo,
              state: item.state,
              extraDeliveryAmt: 0
            });
          });
          this.areaFee = {
            name: '',
            countryCd: this.countryCd,
            details: details
          };
        });
    }
  }
  cancel() {
    if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_CONFIRM1').toString())) {
      window.close();
    }
  }
  save() {
    const areaFee = this.areaFee as PostAreafee;
    let isValid = true;
    if (!areaFee.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT1'));
      (this.$refs.deliveryAreaFeeName as any).focus();
      return;
    }
    let ref = '';
    areaFee.details.forEach(detail => {
      if (typeof detail.extraDeliveryAmt === 'string' && !detail.extraDeliveryAmt) {
        isValid = false;
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT2'));
        ref = 'extraDeliveryAmt' + detail.areaNo;
        (this.$refs[ref] as any)[0].focus();
        return;
      }
    });
    if (!isValid) {
      return;
    }
    const postRequest: PostAreafeesRequest = {
      data: {
        name: areaFee.name,
        countryCd: areaFee.countryCd,
        details: areaFee.details
      }
    };
    this.$api.postAreafees(postRequest).then((res: any) => {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_ALERT3'));
      // 배송비 템플릿 관리화면
      if (window.opener.$('#selectDeliveryAreaFee').length > 0) {
        _.templateSettings = {
          interpolate: /\{\{(.+?)\}\}/g
        };
        const htmlGenerator = _.template('<option value="{{areaFeeNo}}">{{name}}</option>');
        window.opener.$('#selectDeliveryAreaFee').append(htmlGenerator(res.data));
      }

      // 지역별 추가 배송비 관리화면
      if (window.opener.$('#deliveryAreaFeeTable').length > 0) {
        window.opener.location.reload();
      }
      window.close();
    });
  }
  checkNumber(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const result = value.replace(/[^0-9]/g, '');
    (event.target as HTMLInputElement).value = result;
    if (value !== result) {
      (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'block';
    } else {
      (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'none';
    }
  }
  hideNumber(index: number) {
    (document.querySelector(`#errorextraDeliveryAmt${index}`) as HTMLDivElement).style.display = 'none';
  }
  private async mounted() {
    this.$nextTick(() => {
      popupResize(undefined, 1500);
    });
  }
}
